import { Component, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-input',
  imports: [MatInputModule, ReactiveFormsModule],
  template: `
    <mat-form-field appearance="outline" class="w-full" >
    <mat-label>{{to.label}}</mat-label>
    <input matInput input type="number" placeholder="{{to.placeholder}}"  [formControl]="formControl">
  </mat-form-field>
  `,
})
export class CustomFormlyNumber extends FieldType<FieldTypeConfig> {

}